var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-card-header",
            {
              attrs: {
                divider: _vm.showCardText
              }
            },
            [
              _c(
                "v-row",
                {
                  class: _vm.showCardText ? "" : "pb-3"
                },
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        md: "6"
                      }
                    },
                    [_vm._v(" Application Installer ")]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right",
                      attrs: {
                        md: "6"
                      }
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            primary: "",
                            right: ""
                          },
                          on: {
                            click: _vm.togglePanel
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.showButtonLabel) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-expand-transition",
            [
              _c(
                "gg-card-text",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showCardText,
                      expression: "showCardText"
                    }
                  ]
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "keep-alive",
                            [
                              _c("install-app-form", {
                                on: {
                                  "app-installed": _vm.handleAppInstalled
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "gg-card",
        {
          staticClass: "mt-4"
        },
        [
          _c(
            "gg-card-header",
            [
              _c(
                "v-row",
                {
                  staticClass: "align-center",
                  attrs: {
                    "no-gutters": ""
                  }
                },
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "6"
                      }
                    },
                    [_vm._v(" Installed Applications ")]
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "6"
                      }
                    },
                    [
                      _c("gg-text-field", {
                        attrs: {
                          "append-icon": "mdi-magnify",
                          placeholder: "Search",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.tableSearch,
                          callback: function callback($$v) {
                            _vm.tableSearch = $$v
                          },
                          expression: "tableSearch"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("installed-apps-table", {
                        ref: "installedAppsTable",
                        attrs: {
                          search: _vm.tableSearch
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }